import {
  queriesNotifications,
  queriesPayeeRows,
  queriesPayerEngagements
} from "@query";

import { QUERY_BACKGROUND_CHECKS_REQUEST } from "../../query/backgroundChecks/queries/useQueryBackgroundChecksRequest";
import { QUERY_IDENTITY_VERIFICATION_REQUEST } from "../../query/identityVerification/keys";
import { QUERY_INSURANCE_COVERAGES } from "../../query/insuranceCoverage/queries/useQueryInsuranceCoverages";
import { QUERY_INSURANCE_COVERAGE_MONITOR } from "../../query/insuranceCoverageMonitor/queries/useQueryInsuranceCoverageMonitor";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL
} from "../../query/payeeEngagements/keys";
import {
  QUERY_REQUIREMENT,
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE
} from "../../query/requirements/keys";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../query/resourceEvents/queries/useQueryListEvents";
import { QUERY_PAYER_ROWS_ALL } from "../../query/search/payer/queries/useQueryPayerRowsAll";
import { QUERY_SHARED_FILE } from "../../query/sharedFile/keys";
import { QUERY_SIGNED_DOCUMENT } from "../../query/signedDocuments/keys";
import { QUERY_ALL_ENGAGEMENTS_BY_PAYER_IDS } from "../Onboarding/queries/useQueryAllPayersWithEngagements";

export const REQUIREMENTS_DEPENDENCIES = [
  QUERY_SIGNED_DOCUMENT,
  QUERY_SHARED_FILE,
  QUERY_BACKGROUND_CHECKS_REQUEST,
  QUERY_IDENTITY_VERIFICATION_REQUEST,
  QUERY_INSURANCE_COVERAGE_MONITOR,
  queriesNotifications.listNotifications.queryKeyBase,
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE,
  QUERY_REQUIREMENT,
  QUERY_PAYER_ROWS_ALL,
  queriesPayeeRows.searchPayeeRows.queryKeyBase,
  queriesPayerEngagements.getPayerEngagement.queryKeyBase,
  queriesPayerEngagements.listPayerEngagements.queryKeyBase,
  QUERY_ALL_ENGAGEMENTS_BY_PAYER_IDS,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_LIST_RESOURCE_EVENTS,
  QUERY_INSURANCE_COVERAGES
];
